import axios from 'axios';
import account from '@/api/v1/account';

// URL and endpoint constants
// Contacts
const INDEX_URL = '/contacts'; // GET
const PINBOARD_ID = account.user.pinboard;

export default {
  // GET
  index(succ) {
	
    var params = new Object();
	params['pinboard']=PINBOARD_ID;	
	 
	var time= Math.floor(Date.now() / 1000);
    params['time']=time;
    axios.get(INDEX_URL, { params }).then((response) => {
      succ(response.data);
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/contacts.js